import { BioSampleKitType } from '@csp/csp-common-hbs-model';
import { Maybe } from '@csp/csp-common-model';
import { ListTextIconCol } from '@csp/csp-web-ui';
import { SampleKitCode } from '@csp/dmdp-api-hbs-dto';
import { FC, memo } from 'react';
import { BioSampleBaseCol } from '../model/BioSampleBaseCol';
import { BioSampleCodeComponent } from './BioSampleCodeComponent';

type Props = BioSampleBaseCol & {
  kitCode: Maybe<SampleKitCode>;
  kitCodeLabel: string;
  kitType?: BioSampleKitType;
};

export const BioSampleKitCodeCol: FC<Props> = memo(({ kitCode, kitCodeLabel, kitType, ...props }) => (
  <ListTextIconCol
    title={kitCodeLabel}
    text={
      <BioSampleCodeComponent
        sampleCode={undefined}
        containerNumber={undefined}
        kitCode={kitCode || '-'}
        hideSampleCodeSubLabel
        large
        bold
      />
    }
    subLabelProps={{
      text: kitType,
      textProps: {
        color: 'textSecondary',
        noWrap: false,
        lineBreak: 2,
      },
    }}
    {...props}
  />
));

BioSampleKitCodeCol.displayName = 'BioSampleKitCodeCol';
